import {Reducer} from "redux";
import {
    AdLabel,
    Ads, AdsFilter,
    Campaign,
    CampaignsFilter,
    Organization,
    OrganizationsFilter,
    OrganizationsState,
    Profile,
    SampleUsers,
} from "./types";
import {IFeed,} from "../feed/types"
import {
    arrayToObject,
    ILoadNewEntities,
    ILoadNewEntitiesForOrganizationArgs,
    loadNewEntities,
    loadNewEntitiesForOrganization
} from "../../utils";
import {ActionType, getType} from "typesafe-actions";
import * as actions from './actions'
import {fetchAudiUsersAsyncActions, fetchForecastsAsyncActions} from "./actions";

export type OrganizationsAction = ActionType<typeof actions>;

const initialOrganizationsState: OrganizationsState = {
    organizations: {
        byId: {},
    },
    campaigns: {
        byId: {},
    },
    adLabels: {
        byId: {},
    },
    feeds: {
        byId: {},
    },
    profiles: {
        byId: {},
    },
    sampleUsers: {
        byId: {},
    },
    ads: {
        byId: {},
    },
    activeOrganizationId: "",
    activeCampaignIds: [],
    activeAdsId: "",
    organizationsFilter: OrganizationsFilter.SHOW_ACTIVE,
    campaignsFilter: CampaignsFilter.SHOW_ACTIVE,
    adsFilter: AdsFilter.SHOW_ALL,
};

export const organizationsReducer: Reducer<OrganizationsState, OrganizationsAction> = (
    state = initialOrganizationsState,
    action
) => {
    switch (action.type) {
        case getType(actions.fetchOrganizationsAsyncActions.success): {
            return {
                ...state,
                organizations: arrayToObject<Organization>(action.payload.organizations)
            }
        }
        case getType(actions.fetchCampaignsByOrganizationIdAsyncActions.success): {
            let args: ILoadNewEntitiesForOrganizationArgs<Campaign> = {
                state: state,
                organizationId: action.payload.organizationId,
                entityIdsKey: "campaign_ids",
                newEntities: action.payload.campaigns,
                entitiesKey: "campaigns"
            };

            return loadNewEntitiesForOrganization(
                args
            )
        }
        case getType(actions.fetchAdLabelsByOrganizationIdAsyncActions.success): {
            let args: ILoadNewEntitiesForOrganizationArgs<AdLabel> = {
                state: state,
                organizationId: action.payload.organizationId,
                entityIdsKey: "ad_label_ids",
                newEntities: action.payload.adLabels,
                entitiesKey: "adLabels"
            };

            return loadNewEntitiesForOrganization(
                args
            )
        }
        case getType(actions.fetchFeedsByOrganizationIdAsyncActions.success): {
            let args: ILoadNewEntitiesForOrganizationArgs<IFeed> = {
                state: state,
                organizationId: action.payload.organizationId,
                entityIdsKey: "feed_ids",
                newEntities: action.payload.feeds,
                entitiesKey: "feeds"
            };

            return loadNewEntitiesForOrganization(
                args
            )
        }
        case getType(actions.fetchFeedPreviewAsyncActions.success): {
            const {feedId, preview} = action.payload;
            return {
                ...state,
                feeds: {
                    ...state.feeds,
                    byId: {
                        ...state.feeds.byId,
                        [feedId]: {
                            ...state.feeds.byId[feedId],
                            preview: preview
                        }
                    }
                }
            }
        }

        case getType(fetchForecastsAsyncActions.success): {
            let args: ILoadNewEntities<SampleUsers> = {
                state: state,
                newEntities: action.payload.sampleUsers,
                entitiesKey: "sampleUsers"
            };
            return loadNewEntities(args)
        }
        case getType(fetchAudiUsersAsyncActions.success): {
            let args: ILoadNewEntities<Profile> = {
                state: state,
                newEntities: action.payload.profiles,
                entitiesKey: "profiles"
            };
            return loadNewEntities(args)
        }
        case getType(actions.filterAdsAsyncActions.success): {
            const ads = action.payload.ads.filter((ad: Ads) => {
                return ad.ad_type === "template" && ad.content_type === "dpa"
            });
            let args: ILoadNewEntities<Ads> = {
                state: state,
                newEntities: ads,
                entitiesKey: "ads"
            };
            return loadNewEntities(args)
        }
        case getType(actions.setActiveOrganizationIdAction): {
            return {
                ...state,
                activeOrganizationId: action.payload.organizationId
            }
        }
        case getType(actions.setActiveCampaignIdsAction): {
            return {
                ...state,
                activeCampaignIds: action.payload.campaignIds
            }
        }
        case getType(actions.setActiveAdsIdAction): {
            return {
                ...state,
                activeAdsId: action.payload.adsId
            }
        }
        case getType(actions.setOrganizationsFilterAction): {
            return {
                ...state,
                organizationsFilter: action.payload.filter
            }
        }
        case getType(actions.setCampaignsFilterAction): {
            return {
                ...state,
                campaignsFilter: action.payload.filter
            }
        }
        case getType(actions.setAdsFilterAction): {
            return {
                ...state,
                adsFilter: action.payload.filter
            }
        }
        default:
            return state;
    }
};